export interface ComposerSendResult {
  value: string;
  notSent: boolean;
}

export const resolveComposerSend = (
  text: string,
  sent: boolean
): ComposerSendResult =>
  sent ? { value: '', notSent: false } : { value: text, notSent: true };

export interface ComposerDraft {
  id: string;
  text: string;
}

export const draftsAfter = (
  drafts: readonly ComposerDraft[],
  lastTakenId: string | null
): ComposerDraft[] => {
  const index =
    lastTakenId === null
      ? -1
      : drafts.findIndex((draft) => draft.id === lastTakenId);
  return drafts.slice(index + 1);
};

export const withReturnedText = (current: string, returned: string): string =>
  current.trim() ? `${returned}\n${current}` : returned;

export const withoutSentText = (current: string, sent: string): string => {
  if (!sent) return current;
  let at = current.lastIndexOf(`\n${sent}`);
  at = at === -1 ? (current.startsWith(sent) ? 0 : -1) : at + 1;
  if (at === -1) return current;
  const before = current.slice(0, at).replace(/\n$/, '');
  const after = current.slice(at + sent.length).trimStart();
  return before && after ? `${before}\n${after}` : before || after;
};
